module.exports = __webpack_public_path__ + "img/dog-grey.ab7e4b82.png";